import React from "react";
import { Box, Typography, Chip, Tooltip } from "@mui/material";
import { FCard } from "@ui/components/card";
import { SecondaryGrid } from "@ui/components/grid";
import { eventLogData as defaultData } from "./data";
import { useTranslation } from "react-i18next";
import { formatUtcToLocalDateTimeString } from "@application/common/helpers/date-util";
// Helper to get chip color based on flag
const getFlagColor = (flag) => {
    switch (flag) {
        case "TempLow":
        case "TempHigh":
            return "error";
        case "PowerOn":
        case "SwitchOpen":
            return "success";
        case "PowerOff":
        case "SwitchClosed":
            return "warning";
        default:
            return "default";
    }
};
// Helper to get display label for flag
const getFlagLabel = (flag) => {
    switch (flag) {
        case "TempLow":
            return "Temp Low";
        case "TempHigh":
            return "Temp High";
        case "PowerOn":
            return "Power On";
        case "PowerOff":
            return "Power Off";
        case "SwitchOpen":
            return "Switch Open";
        case "SwitchClosed":
            return "Switch Closed";
        case "None":
            return "None";
        default:
            return flag;
    }
};
// Full text for tooltip: support multiple flags (comma-separated) with readable labels
const getFlagTooltipText = (flag) => {
    if (!flag || flag === "None")
        return "None";
    return flag
        .split(",")
        .map((f) => getFlagLabel(f.trim()))
        .join(", ");
};
export const EventLog = ({ title = "Event log", data = defaultData, loading = false, rowCount = 0, paginationModel = { page: 0, pageSize: 25 }, onPaginationModelChange, pageSizeOptions = [25, 50], }) => {
    const { t } = useTranslation("common");
    const eventLogColumns = [
        {
            field: "dateTime",
            headerName: t("grid.dateTime"),
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatUtcToLocalDateTimeString(params.row.dateTime),
        },
        {
            field: "flag",
            headerName: t("grid.flag"),
            flex: 1,
            minWidth: 120,
            renderCell: (params) => {
                var _a;
                const flag = params.row.flag || "None";
                const tooltipText = getFlagTooltipText(flag);
                const displayLabel = flag.indexOf(",") >= 0
                    ? getFlagTooltipText(flag)
                    : getFlagLabel(flag);
                return (React.createElement(Tooltip, { title: tooltipText, enterDelay: 300, placement: "top-start" },
                    React.createElement(Chip, { label: displayLabel, color: getFlagColor(((_a = flag.split(",")[0]) === null || _a === void 0 ? void 0 : _a.trim()) || flag), size: "small", sx: { maxWidth: "100%", "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis" } } })));
            },
        },
        {
            field: "battery",
            headerName: t("grid.battery"),
            flex: 1,
            minWidth: 100,
            renderCell: (params) => params.row.battery || "N/A",
        },
        {
            field: "version",
            headerName: t("grid.version"),
            flex: 0.5,
            minWidth: 80,
            renderCell: (params) => { var _a; return (_a = params.row.version) !== null && _a !== void 0 ? _a : "N/A"; },
        },
        {
            field: "temperature",
            headerName: t("grid.temperature"),
            flex: 1,
            minWidth: 100,
        },
    ];
    // if (loading) {
    //   return (
    //     <FCard variant="default">
    //       <Box pt={1.5} px={1.5}>
    //         <Skeleton variant="text" width={100} height={28} sx={{ mb: 1 }} />
    //         <Skeleton variant="rectangular" height={200} />
    //       </Box>
    //     </FCard>
    //   );
    // }
    return (React.createElement(FCard, { variant: "default" },
        React.createElement(Box, { pt: 1.5, px: 1.5 },
            React.createElement(Typography, { variant: "h6" }, title),
            React.createElement(SecondaryGrid, { rows: data, loading: loading, columns: eventLogColumns, paginationMode: "server", rowCount: rowCount, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange, pageSizeOptions: pageSizeOptions, fillRemainingSpace: false, useAutoHeight: false, gridMaxHeight: 450, headerBackgroundColor: "#F4F6F8" }))));
};
